'use client';

import Image from 'next/image';
import Link from 'next/link';
import { getReadableImageUrl } from '@/lib/directus'
import { sanitizeHTML } from '@/lib/utils'
import Breadcrumbs from '@/components/Secondary/Breadcrumbs/Breadcrumbs';


interface GalleryBridgeProps {
	data: {
		content_collection: {
			id: string
			site_content_collections_id: {
				collection: {
					item: {
						image_file?: {
							image: {
								id: string
								filename_download: string
							}
						}
						menu_items?: Array<{
							menu_items_id: {
								label: string
								href: string
							}
						}>
						title?: string
						alt?: string
					}
				}[]
			}
		}[]
	}
}

export const fields = [
	'content_collection.id',
  'content_collection.site_content_collections_id.collection.item.image_file.image.id',
  'content_collection.site_content_collections_id.collection.item.image_file.image.filename_download',
  'content_collection.site_content_collections_id.collection.item.menu_items.menu_items_id.label',
  'content_collection.site_content_collections_id.collection.item.menu_items.menu_items_id.href',
	'content_collection.site_content_collections_id.collection.item:site_content.title',
] as const

export default function GalleryBridge({ data }: GalleryBridgeProps) {
  return (
		<>
			<Breadcrumbs />
			<section className='GalleryBridgeProps w-full pb-16'>
				<div className='container max-md:p-0 relative'>
					<div className='flex flex-col lg:flex-row md:gap-16 overflow-hidden'>
						{data.content_collection.map((section, index) => (
							<div
								key={section.id}
								className={`w-full lg:flex-1 bg-[#f5f5f5] ${
									index === 0 ? 'rounded-br-[4rem]' : 'rounded-bl-[4rem]'
								} flex flex-col`}
							>
								<div
									className={`relative w-full h-[20rem] ${
										index === 1 ? 'lg:h-[32rem]' : 'lg:h-[18rem]'
									}`}
								>
									<Image
										src={getReadableImageUrl(
											section.site_content_collections_id.collection[1]?.item
												?.image_file?.image?.id || '',
											section.site_content_collections_id.collection[1]?.item
												?.image_file?.image?.filename_download || ''
										)}
										alt={
											section.site_content_collections_id.collection[1]?.item
												?.alt ||
											`${index === 0 ? 'Surgical' : 'Non-Surgical'} Procedures`
										}
										fill
										className={`object-cover ${
											index === 0
												? 'md:object-center object-[70%_0]'
												: 'object-center'
										}`}
										sizes='(max-width: 1024px) 100vw, 50vw'
										priority
									/>
									<div className='absolute top-6 left-6 max-lg:text-white max-lg:top-[10px] max-lg:left-6 lg:bottom-6 lg:right-6 lg:left-auto lg:top-auto lg:text-black font-brandon font-medium tracking-wide text-lg'>
										Model
									</div>
								</div>
								<div className='px-8 lg:px-16 py-12 lg:py-16 flex flex-col gap-12'>
									<div className='flex flex-col gap-4'>
										<h2
											dangerouslySetInnerHTML={sanitizeHTML(
												section.site_content_collections_id.collection[0]?.item
													?.title || (index === 0 ? 'Surgical' : 'Non-Surgical')
											)}
										/>
										<p className='text-base lg:text-lg uppercase tracking-[0.2em]'>
											Procedures
										</p>
									</div>
									<div className='flex flex-col gap-4 lg:gap-6'>
										{section.site_content_collections_id.collection[2]?.item?.menu_items?.map(
											item => (
												<Link
													key={item.menu_items_id.label}
													href={item.menu_items_id.href}
													className='text-xl uppercase tracking-[0.15em] hover:text-primary transition-colors'
												>
													{item.menu_items_id.label}
												</Link>
											)
										)}
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>
		</>
	)
}